// extracted by mini-css-extract-plugin
export default {"root":"AboutCourse_root__Hkk6F","blob":"AboutCourse_blob__fCzcz","bubbleRoot":"AboutCourse_bubbleRoot__g32uo"};